import { type FC } from 'react';

import { Tag } from '@vakantiesnl/components/src/atoms/Tag';
import { Typography } from '@vakantiesnl/components/src/atoms/Typography';
import { useStyles } from '@vakantiesnl/components/src/molecules/PriceOverview/PriceOverview.style';
import { useBreakpoints } from '@vakantiesnl/components/src/utils/useBreakpoints';
import { usePriceToDecimalString } from '@vakantiesnl/services/src/hooks/utils/hook';
import { type Coupon } from '@vakantiesnl/types/src/booking/coupon';

type Props = {
	discount: Coupon;
};

/** Applied coupon display */
export const Discount: FC<Props> = ({ discount }) => {
	const { classes } = useStyles();
	const { isDesktop } = useBreakpoints();

	const discountPrice = usePriceToDecimalString(discount.price);
	/** Shouldn't be a negative number like € -100,00 but a distraction of an amount like - € 100,00 */
	const formattedDiscount = discountPrice.includes('-') ? `- ${discountPrice.replace('-', '')}` : '';

	return (
		<tr data-cy="price-table-discount" className={classes.centeredRow}>
			<th>
				<Tag color="teal" variant="filled">
					{discount.couponcode || discount.description}
				</Tag>
			</th>
			<Typography variant={isDesktop ? 'bodyMd' : 'bodySm'} as="td" className={classes.positivePrice}>
				{formattedDiscount}
			</Typography>
		</tr>
	);
};
